import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/login/index'
import Code from '../components/login/weixinLogin/code/code'
import Register from '../components/login/register'
import Userlable from '../components/login/userlable'
import Findpass from '../components/login/findpass'
import Index from '../components/index'
import Live from '../components/live'
import Testlist from '../components/live/testlivelist'
import Clear from '../components/clear'
import Video from '../components/video'
import Allvideo from '../components/video/alllist'
import Me from '../components/me'


import Column from '../components/column'
import colDetails from '../components/column/colDetails'
import EditInfo from '../components/me/editingInfo'
import End from '../components/me/end'

import Achievement from '../components/me/achievement'
import TaskList from '../components/me/TaskList'
import Examination from '../components/me/examination'
import Answer from '../components/me/answer'
import MyBuy from '../components/me/myBuy'
import Ccreslut from '../components/me/ccreslut'
import UserInfor from '../components/me/userInfor'
import ShareQRCode from '../components/me/ShareQRCode/ShareQRCode'
import SubscribeQRCode from '../components/me/SubscribeQRCode/SubscribeQRCode'
import upay from '../components/me/upay'
import payOk from '../components/me/payOk'
import AchieveCar from '../components/me/achieveCar'
import Feedback from '../components/me/feedback'
import Bind from '../components/me/bindMobile'
import About from '../components/me/about'


import Collection from '../components/me/collection'
import Bespoke from '../components/me/bespoke'
import Details from '../components/container/details'
import vDetails from '../components/container/vDetails'
import demovideo from '../components/container/demovideo'

import Member from '../components/member'
import AddMem from '../components/member/addMem'

Vue.use(Router)

const router= new Router({
    mode: "history",
    // TODO 正则上线时要把下面注释去了
    base: AppSetting.RouterBase,
    routes: [{
        path: "/",
        redirect: "/index/live"
    },
    {
        path: '/clear',
        name: 'Clear',
        component: Clear
    }, {
        path: '/login',
        name: 'Login',
        component: Login
    }, {
        path: '/weixinLogin/code',
        name: 'Code',
        component: Code
      }, {
        path: '/register',
        name: 'Register',
        component: Register
    }, {
        path: '/userlable',
        name: 'Userlable',
        component: Userlable
    }, {
        path: '/findpass',
        name: 'Findpass',
        component: Findpass
    }, {
        path: '/findpass',
        name: 'Findpass',
        component: Findpass
    }, {
        path: '/details',
        name: 'Details',
        component: Details,
    },
    {
      path: '/vDetails',
      name: 'vDetails',
      component: vDetails,
      meta: {
          keepAlive: true
      }
  },{
    path: '/demovideo',
    name: 'demovideo',
    component: demovideo,
    meta: {
        keepAlive: true
    }
},

    {
        path: '/coldetails',
        name: 'colDetails',
        component: colDetails,
    }, {
        path: '/editInfo',
        name: 'EditInfo',
        component: EditInfo,
    },
    {
        path: '/achievement',
        name: 'Achievement',
        component: Achievement,
    },
    {
        path: '/taskList',
        name: 'TaskList',
        component: TaskList,
    },
    {
        path: '/examination',
        name: 'Examination',
        component: Examination,
    },
    {
        path: '/answer',
        name: 'Answer',
        component: Answer,
    },
    {
        path: '/myBuy',
        name: 'MyBuy',
        component: MyBuy,
        meta: {
            keepAlive: true,
            keepAliveChange: false
        }
    },
    {
        path: '/ccreslut',
        name: 'Ccreslut',
        component: Ccreslut,
    },


    {
        path: '/end',
        name: 'End',
        component: End,
    }, {
        path: '/bespoke',
        name: 'Bespoke',
        component: Bespoke,
    }, {
        path: '/collection',
        name: 'Collection',
        component: Collection,
        meta: {
            keepAlive: true,
            keepAliveChange: false
        }
    },
    {
        path: '/member',
        name: 'Member',
        component: Member
    },
    {
        path: '/addMem',
        name: 'AddMem',
        component: AddMem
    },
    {
        path: '/index/allvideo',
        name: 'Allvideo',
        component: Allvideo,
        meta: {
            keepAlive: true,
            keepAliveChange: false
        }
    },
    {
        path: '/testlivelist',
        name: 'Testlist',
        component: Testlist,
        meta: {
            keepAlive: true,
            keepAliveChange: false
        }
    },
    {
        path: '/userInfor',
        name: 'UserInfor',
        component: UserInfor
    },
    {
        path: '/ShareQRCode',
        name: 'ShareQRCode',
        component: ShareQRCode
    }, {
        path: '/SubscribeQRCode',
        name: 'SubscribeQRCode',
        component: SubscribeQRCode
      },
    {
        path: '/upay',
        name: 'upay',
        component: upay
    },
    {
        path: '/payOk',
        name: 'payOk',
        component: payOk
    },
    {
        path: '/achieveCar',
        name: 'AchieveCar',
        component: AchieveCar
    },
    {
        path: '/feedback',
        name: 'Feedback',
        component: Feedback
    },
    {
        path: '/about',
        name: 'About',
        component: About
    },
    {
        path: '/bind',
        name: 'Bind',
        component: Bind
    },
    {
        path: '/index',
        name: 'Index',
        component: Index,
        children: [{
            path: "/index",
            redirect: "/index/live"
        },
        {
            path: '/index/live',
            name: 'Live',
            component: Live,
            meta: {
                keepAlive: true,
                keepAliveChange: false
            }

        },
        {
            path: '/index/video',
            name: 'Video',
            component: Video,
            meta: {
                keepAlive: true,
                keepAliveChange: false
            }
        }, {
            path: '/index/me',
            name: 'Me',
            component: Me
        },
        {
            path: '/index/column',
            name: 'Column',
            component: Column
        },
        ]
    }
    ]
})

import AppSetting from '../AppSetting'


import SSOGard from './gard/SSOGard'
import ShareKeyGard from './gard/ShareKeyGard'
import SubscribeGard from './gard/SubscribeGard'
import KeepAliveGard from './gard/KeepAliveGard'
import UserInfoGard from './gard/UserInfoGard'

// 自动登录
router.beforeEach(ShareKeyGard)
// 获取用户信息，单点登录
router.beforeEach(SSOGard)
// 验证手机号是否填写
router.beforeEach(UserInfoGard)
// 必须关注公众号
router.beforeEach(SubscribeGard)
// 保持状态
router.beforeEach(KeepAliveGard)

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js